export default __webpack_public_path__ + "static/backstage-c1e7d918a656cfb80639dbbc2dfc004f.svg";